export const Meta = (section = '') => ({
  head() {
    const result = { meta: [] };

    if (this.$t(`${section}.meta-title`).length) {
      result.title = this.$t(`${section}.meta-title`);
    }

    if (this.$t(`${section}.meta-description`).length) {
      result.meta.push({
        name: 'description',
        hid: 'description',
        content: this.$t(`${section}.meta-description`),
      });
    }

    if (this.$t(`${section}.meta-keywords`).length) {
      result.meta.push({
        name: 'keywords',
        hid: 'keywords',
        content: this.$t(`${section}.meta-keywords`),
      });
    }

    return result;
  },
});
